// extracted by mini-css-extract-plugin
module.exports = {"container":"_0a66","title":"c353","text":"c5d6","countDown":"_33eb","countDownItem":"_72bb","separate":"_191d","numberDiv":"ebaa","number":"e10f","numberText":"_1f1a"};